module.exports = __webpack_public_path__ + "static/img/8.fe3129f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/sp/8.png
// module id = Vozv
// module chunks = 0